import { get, post, put, del } from '../lib/apiClient';

/**
 * GET /tasks — the caller's tasks (owner defaults to the authenticated user;
 * listing someone else's requires tasks:read:all). Query: status, priority,
 * owner, project, updatedSince, limit, lastEvaluatedKey.
 */
export const listTasks = (query) => get('/tasks', { query });

/** POST /tasks — TaskWrite body; server owns id/createdAt/updatedAt */
export const createTask = (payload) => post('/tasks', payload);

/** GET /tasks/{taskId} */
export const getTask = (taskId) => get(`/tasks/${encodeURIComponent(taskId)}`);

/**
 * PUT /tasks/{taskId} — omitted fields stay unchanged;
 * blockers/dependencies/attachments are replaced wholesale when present.
 */
export const updateTask = (taskId, payload) =>
  put(`/tasks/${encodeURIComponent(taskId)}`, payload);

/** DELETE /tasks/{taskId} */
export const deleteTask = (taskId) => del(`/tasks/${encodeURIComponent(taskId)}`);
